import Navbar from './components/Navbar';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import LibrarySection from './components/LibrarySection';
import SeasonSection from './components/SeasonSection';
import PicksSection from './components/PicksSection';
import ClassicsSection from './components/ClassicsSection';
import GuideSection from './components/GuideSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

const marqueeWords = [
  '热血战斗',
  '科幻机甲',
  '奇幻冒险',
  '悬疑推理',
  '日常治愈',
  '校园青春',
  '新番导视',
  '完结神作',
  '高清画质',
  '全集资源',
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />

        <div className="w-full bg-primary-500 text-background-50 overflow-hidden">
          <div className="flex whitespace-nowrap py-3 animate-marquee">
            {[0, 1].map((dup) => (
              <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
                {marqueeWords.map((word) => (
                  <span
                    key={`${dup}-${word}`}
                    className="flex items-center gap-3 px-5 text-sm md:text-base"
                  >
                    <i className="ri-video-line text-accent-200"></i>
                    {word}
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>

        <RankingSection />
        <LibrarySection />
        <SeasonSection />
        <PicksSection />
        <ClassicsSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}